import React,{ useRef,useState } from 'react';
import './App.css';
import { Routes, Route,useParams } from "react-router-dom";
import MainPage from './960x540/MainPage';
import PreviewPage from './960x540/PreviewPage';
import Page404 from './960x540/Page404';


function App() {
    const config = { 
        hostApi : 'https://vision.net.last40.com/api/',
      }

  React.useEffect(() => {
  }, []);

  return (
    <Routes>
      <Route path="*" element={<Page404 />} />
      <Route path="/" element={<MainPage config={config} />} />
      <Route path="/prev/:id" element={<PreviewPage config={config} />} />
    </Routes>
  );
}

export default App;
